import PropTypes from 'prop-types';

const SwitchTableButton = ({ value, onChange, tabNames }) => {
  return (
    <div className='flex gap-2 h-9 bg-[#F0F1F2]  rounded-md items-center justify-around'>
      {tabNames.map(item => (
        <div key={item} className='w-[55%] py-1 px-1 font-bold text-sm rounded-md outline-0'>
          <button
            onClick={() => {
              onChange(item);
            }}
            className={value === item ? 'rounded-md bg-white p-1 shadow' : 'bg-[#F0F1F2] p-1'}
          >
            {item}
          </button>
        </div>
      ))}
    </div>
  );
};

SwitchTableButton.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  tabNames: PropTypes.array,
};

export default SwitchTableButton;
